import { Record, List } from 'immutable';
import ErrorRecord from '~/data/ErrorRecord';
import GatewayRecord from './GatewayRecord';

const keys: Fields = {
  isLoading: false,
  forceReload: false,
  stationaryGateways: List(),
  mobileGateways: List(),
  error: undefined,
  removeGatewayError: undefined,
};

interface Fields {
  isLoading: boolean;
  forceReload: boolean;
  stationaryGateways: List<GatewayRecord>;
  mobileGateways: List<GatewayRecord>;
  error?: ErrorRecord;
  removeGatewayError?: ErrorRecord;
}

export const createGatewayRecordList = (gateways): List<GatewayRecord> =>
  List(gateways.map((gateway) => new GatewayRecord(gateway)));

export default class GatewaysRecord extends Record<Fields>(keys) {
  updateGateway(gatewayId, updateFunction) {
    const stationaryIndex = this.stationaryGateways.findIndex(
      (gateway) => gateway.id === gatewayId
    );
    const mobileIndex = this.mobileGateways.findIndex(
      (gateway) => gateway.id === gatewayId
    );

    if (stationaryIndex !== -1) {
      return this.updateIn(
        ['stationaryGateways', stationaryIndex],
        updateFunction
      );
    } else if (mobileIndex !== -1) {
      return this.updateIn(['mobileGateways', mobileIndex], updateFunction);
    }

    return this;
  }

  removeGatewayFromList(gatewayId) {
    const stationaryIndex = this.stationaryGateways.findIndex(
      (gateway) => gateway.id === gatewayId
    );
    const mobileIndex = this.mobileGateways.findIndex(
      (gateway) => gateway.id === gatewayId
    );

    if (stationaryIndex !== -1) {
      return this.removeIn(['stationaryGateways', stationaryIndex]);
    } else if (mobileIndex !== -1) {
      return this.removeIn(['mobileGateways', mobileIndex]);
    }

    return this;
  }
}
